import { useCallback, useEffect, useState } from 'react';
import {
  fetchSchoolHomePageData,
  getStatFromMap,
  SCHOOL_HOME_PAGE_STAT_LABELS,
} from '../utils/schoolHomePageStats';

const useSchoolHomePageStats = () => {
  const [statsMap, setStatsMap] = useState({});
  const [pricingPlans, setPricingPlans] = useState([]);

  useEffect(() => {
    const controller = new AbortController();

    fetchSchoolHomePageData(controller.signal)
      .then(({ statsMap: nextStatsMap, pricingPlans: nextPricingPlans }) => {
        setStatsMap(nextStatsMap);
        setPricingPlans(nextPricingPlans);
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.error('School home page API:', err.message);
        }
      });

    return () => controller.abort();
  }, []);

  const getStat = useCallback(
    (label) => getStatFromMap(statsMap, label),
    [statsMap],
  );

  const schoolsCount = getStat(SCHOOL_HOME_PAGE_STAT_LABELS.totalSchools);

  return { statsMap, getStat, schoolsCount, pricingPlans };
};

export default useSchoolHomePageStats;
